import type { SxProps, Theme } from '@mui/material'

export const tableGlobalFilterStyles: Record<string, SxProps<Theme>> = {
  mobileInputProps: {
    paddingRight: '0 !important',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    '& .MuiOutlinedInput-notchedOutline': {
      borderRight: 'none',
    },
  },
  searchSlotContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}
